/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aifeatureeventphoto3Inputs */

const en_aifeatureeventphoto3 = /** @type {(inputs: Aifeatureeventphoto3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Own photo with text`)
};

const de_aifeatureeventphoto3 = /** @type {(inputs: Aifeatureeventphoto3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigenes Foto mit Text`)
};

/**
* | output |
* | --- |
* | "Own photo with text" |
*
* @param {Aifeatureeventphoto3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aifeatureeventphoto3 = /** @type {((inputs?: Aifeatureeventphoto3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aifeatureeventphoto3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aifeatureeventphoto3(inputs)
	return de_aifeatureeventphoto3(inputs)
});
export { aifeatureeventphoto3 as "aiFeatureEventPhoto" }